module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mediaLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _vm._l((_vm.docMediaTypes), function(mediaType) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label text-label"
    }, [_vm._v(_vm._s(mediaType.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mediaList.find(function (x) {
          return x.mediaTypeId === mediaType.mediaTypeId
        })),
        expression: "mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})"
      }],
      staticClass: "table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((_vm.mediaList.filter(function (m) {
      return m.mediaTypeId === mediaType.mediaTypeId
    })), function(mediaItem) {
      return _c('tr', [_c('td', [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('a', {
        staticClass: "fa fa-cloud-download",
        staticStyle: {
          "font-size": "18px"
        },
        attrs: {
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            _vm.mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)
          }
        }
      })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.createdBy))]), _vm._v(" "), _c('td', [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('a', {
        staticClass: "fa fa-ban",
        staticStyle: {
          "font-size": "18px"
        },
        attrs: {
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            _vm.mediaRemove(mediaItem.mediaId)
          }
        }
      })])])])
    }))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(_vm.mediaList.find(function (x) {
          return x.mediaTypeId === mediaType.mediaTypeId
        }))),
        expression: "!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))"
      }]
    }, [_c('label', [_vm._v("No matching records")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Add File")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "documentForm",
      "data-vv-scope": "mediaFile"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.mediaType')
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaTypeId),
      expression: "mediaTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mediaType",
      "data-vv-validate-on": "none"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mediaTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.docMediaTypes), function(mediaType) {
    return _c('option', {
      domProps: {
        "value": mediaType.mediaTypeId
      }
    }, [_vm._v("\n                                    " + _vm._s(mediaType.name) + "\n                                ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.mediaType')),
      expression: "errors.has('mediaFile.mediaType')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Media type is required")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.newFile')
    }
  }, [_c('label', [_vm._v("File")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "newFile",
    staticClass: "file",
    attrs: {
      "name": "newFile",
      "type": "file",
      "data-vv-validate-on": "none"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.newFile')),
      expression: "errors.has('mediaFile.newFile')"
    }],
    staticClass: "has-error"
  }, [_vm._v("File is required")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any('mediaFile')),
      expression: "errors.any('mediaFile')"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to upload")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrorList.length > 0),
      expression: "serverErrorList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.serverErrorList), function(serverError) {
    return _c('li', {
      key: serverError
    }, [_vm._v(_vm._s(serverError))])
  }))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-1",
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("Upload")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Delete")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-056722e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReconFormDocuments.vue
// module id = 888
// module chunks = 1